import GroupsIcon from '@mui/icons-material/Groups';
import { EmployeeServicePath, NODE_LEAVES_LIST } from "utils/constants";
import NodeLeavesList from "./List";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <GroupsIcon />,
  name: EmployeeServicePath + NODE_LEAVES_LIST,
  title: "Отпуски на звеното",
  list: <NodeLeavesList />,
  permission: permissions.canPreviewNodeLeaveRequests,
};
